import React from 'react';
import REST from 'go/requests/rest';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {Segment, Header, Dropdown, Confirm, Grid, Message} from 'semantic-ui-react';
import _ from 'lodash';
import ReopenApplicationModal from 'go/components/modules/application/ReopenApplicationModal';
import InitiateCloseoutReportModal from 'go/components/modules/application/InitiateCloseoutReportModal';
import InitiateSubCloseoutReportModal from 'go/components/modules/application/InitiateSubCloseoutReportModal';
import CancelCloseoutReportModal from 'go/components/modules/application/CancelCloseoutReportModal';
import CancelSubCloseoutReportModal from 'go/components/modules/application/CancelSubCloseoutReportModal';
import CreateEntityActionButton from './CreateEntityActionButton';
import {
  ASSOCIATED_ENTITY_STATUSES,
  STATUS_AWARD_ACCEPTED,
  STATUS_AWARD_OFFERED,
  STATUS_CLOSEOUT_INITIATED,
  STATUS_ADMINISTRATIVE_CLOSEOUT_INITIATED,
  STATUS_ADMINISTRATIVELY_CLOSED,
  STATUS_RETURNED_TO_RECIPIENT,
  STATUS_PENDING_SUBMISSION,
  STATUS_PENDING_AOR_SIGNATURE,
  STATUS_REVIEW_COMPLETED,
  STATUS_SUBMITTED_TO_FEMA,
  STATUS_CLOSED,
} from 'app-ui-componentlibrary/dist/common/constants';

import {PAYMENT} from 'common/requestDetails/constants.js';

import {
  ISOToDisplayDate,
  getGrantActions,
  matchesToggle,
  convertUTCDateToLocalDateDisplay,
} from 'common/utils';
import {withRouter} from 'react-router-dom';
import {Toggle} from 'componentLibrary';
import {
  canViewPostAwardEntities,
  canReopenApplications,
  canContinueApplications,
  canViewRFI,
  canInitiateOrContinueSubCloseoutReport,
  canEditPropertyData,
} from 'go/security/permissions';
import produce from 'immer';

export class MyToDoList extends React.Component {
  state = {
    withdrawModalOpen: false,
    reopenModalOpen: false,
    initiateCloseoutReportModalOpen: false,
    initiateSubCloseoutReportModalOpen: false,
    selectedEntity: {},
    selectedEntityType: {},
    withdrawShowMessage: false,
    applications: [],
    cancelCloseoutReportModalOpen: false,
    cancelSubCloseoutReportModalOpen: false,
    propertyData: [],
  };

  showReopenModal = (entity) => {
    this.setState({
      selectedEntity: entity,
      reopenModalOpen: true,
    });
  };

  handleInitiateCloseoutReport = () => {
    this.setState({initiateCloseoutReportModalOpen: false});
  };

  handleOnCancelInitiateSubCloseoutReport = () => {
    this.setState({initiateSubCloseoutReportModalOpen: false});
  };

  showInitiateCloseoutReportModal = (entity, entityType) => {
    this.setState({
      selectedEntity: entity,
      selectedEntityType: entityType,
      initiateCloseoutReportModalOpen: true,
    });
  };

  showInitiateSubCloseoutReportModal = (entity, entityType) => {
    this.setState({
      selectedEntity: entity,
      selectedEntityType: entityType,
      initiateSubCloseoutReportModalOpen: true,
    });
  };

  handleCancelCloseoutReport = () => {
    this.setState({cancelCloseoutReportModalOpen: false});
  };

  showCancelCloseoutReportModal = (entity) => {
    this.setState({
      selectedEntity: entity,
      cancelCloseoutReportModalOpen: true,
    });
  };

  handleCancelSubCloseoutReport = () => {
    this.setState({cancelSubCloseoutReportModalOpen: false});
  };

  showCancelSubCloseoutReportModal = (entity) => {
    this.setState({
      selectedEntity: entity,
      cancelSubCloseoutReportModalOpen: true,
    });
  };

  showWithdrawModal = () => {
    this.setState({withdrawModalOpen: true});
  };

  onClose = () => {
    this.setState({withdrawShowMessage: false});
  };

  handleConfirmWithdraw = () => {
    const {amendments, payments, saveEntitySessionData, token} = this.props;
    let entity = produce(this.state.selectedEntity, (draft) => {
      draft.status = 'withdrawn';
    });
    REST.dynamicData
      .updateEntity(token, entity)
      .then(REST.handler.handleResponse)
      .then(() => {
        const findIndex = (entities) =>
          _.findKey(entities, (e) => _.isEqual(e.entityId, entity.entityId));

        switch (entity.entityType) {
          case 'amendment':
            saveEntitySessionData(`context.amendments[${findIndex(amendments)}]`, entity);
            break;
          case 'payment':
            saveEntitySessionData(`context.payments[${findIndex(payments)}]`, entity);
            break;
          default:
        }

        this.setState({
          withdrawShowMessage: true,
          withdrawModalOpen: false,
        });
      });
  };

  handleCancel = () => {
    this.setState({withdrawModalOpen: false, reopenModalOpen: false});
  };

  componentDidMount() {
    this.refreshData();
  }

  componentDidUpdate(prevProps) {
    const {
      data,
      grant,
      permissions,
      amendments,
      payments,
      rfis,
      performanceProgressReports,
      closeoutReports,
      subCloseoutReports,
    } = this.props;
    if (
      !_.isEqual(amendments, prevProps.amendments) ||
      !_.isEqual(payments, prevProps.payments) ||
      !_.isEqual(performanceProgressReports, prevProps.performanceProgressReports) ||
      !_.isEqual(rfis, prevProps.rfis) ||
      !_.isEqual(closeoutReports, prevProps.closeoutReports) ||
      (data &&
        grant &&
        permissions &&
        (!_.isEqual(grant, prevProps.grant) ||
          permissions !== prevProps.permissions ||
          data !== prevProps.data))
    ) {
      this.refreshData();
    }
  }

  refreshData() {
    const {token, data: grantId, entities, permissions, grant, toggles} = this.props;
    this.setState({tasks: []});
    if (canViewPostAwardEntities(permissions)) {
      switch (_.get(grant, 'status')) {
        case STATUS_AWARD_OFFERED:
          let getWorkflowTasksBody = {};
          if (!_.isEmpty(permissions)) {
            getWorkflowTasksBody.candidateGroups = permissions;
          }
          _.assign(getWorkflowTasksBody, {
            includeAssignedTasks: true,
            processVariables: [
              {
                name: 'grantId',
                value: `%${grantId}%`,
                operator: 'like',
              },
            ],
            taskDefinitionKey: 'awardAcceptance',
          });
          REST.workflow
            .getAllExternalEligibleTasks(
              token,
              ['grantId', 'awardAcceptanceDueDate'],
              getWorkflowTasksBody
            )
            .then(REST.handler.handleResponse)
            .then((resJson) => this.setState({tasks: resJson}));
          break;
        case STATUS_CLOSEOUT_INITIATED:
        case STATUS_ADMINISTRATIVE_CLOSEOUT_INITIATED:
        case STATUS_ADMINISTRATIVELY_CLOSED:
        case STATUS_AWARD_ACCEPTED:
          const {
            payments,
            amendments,
            performanceProgressReports,
            closeoutReports,
          } = this.props;
          const nonToggledEntities = [
            'payment',
            'amendment',
            'subAmendmentRecommendation',
            'performanceProgressReport',
            'closeoutReport',
          ];
          const toggledEntities = _.intersectionWith(
            entities,
            toggles,
            (entity, toggle) =>
              matchesToggle(
                entity,
                toggle,
                'fundingOpportunity',
                grant.fundingOpportunityId
              )
          );

          const allAllowedEntities = _.union(toggledEntities, nonToggledEntities);
          const filterEntity = (entities) =>
            _.filter(
              entities,
              (entity) =>
                _.find(allAllowedEntities, (toggle) =>
                  _.isEqual(entity.entityType, toggle)
                ) !== undefined
            );

          this.setState({
            entities: filterEntity(amendments).concat(filterEntity(payments)),
          });

          //Retrieve the financial report tasks from workflow by the grant id
          this.getJoinedEntityTaskData(
            'financialReport',
            'submitFinancialReport',
            STATUS_PENDING_SUBMISSION,
            'financialReports'
          );

          //Retrieve the BSIR tasks from workflow by the grant id
          let bsirReporting = _.get(
            this.props.context,
            'fundingOpportunityData.configData.reporting.bsirReporting'
          );
          if (bsirReporting == true) {
            this.getJoinedEntityTaskData(
              'bsirReport',
              'submitBSIRReport',
              STATUS_PENDING_SUBMISSION,
              'bsirReports'
            );
          }

          // Retrieve the PPR tasks from workflow by the grant id
          _.includes(toggles, 'pprScheduler')
            ? this.getJoinedEntityTaskData(
                'performanceProgressReport',
                'submitPPRReport',
                [STATUS_PENDING_SUBMISSION, STATUS_RETURNED_TO_RECIPIENT],
                'performanceProgressReports'
              )
            : this.setState({
                performanceProgressReports: filterEntity(
                  _.filter(
                    performanceProgressReports,
                    (report) =>
                      report.status != STATUS_SUBMITTED_TO_FEMA &&
                      report.status != STATUS_REVIEW_COMPLETED
                  )
                ),
              });

          this.setState({
            closeoutReports: filterEntity(
              _.filter(
                closeoutReports,
                (report) => report.status != STATUS_SUBMITTED_TO_FEMA
              )
            ),
          });

          break;
        case STATUS_PENDING_SUBMISSION:

        case STATUS_PENDING_AOR_SIGNATURE:
        case STATUS_SUBMITTED_TO_FEMA:
          REST.dynamicData
            .getAllByGrantIdAndEntityType(token, grantId, 'application')
            .then(REST.handler.handleResponse)
            .then((resp) => this.setState({applications: resp}));
          break;
        default:
          this.getApplicationExtension(grant);
      }
    }
    if (
      canViewRFI(
        permissions,
        _.get(this.props.context, 'grant.organizationId'),
        _.get(this.props.context, 'subGrant.programId'),
        _.get(this.props.context, 'grant.programId')
      )
    ) {
      const subGrantId = _.get(this.props.context, 'subGrant.subGrantId');
      const grantId = _.get(this.props.context, 'grant.grantId');
      const id = subGrantId === undefined ? grantId : subGrantId;

      let getWorkflowTasksBody = {};

      _.assign(getWorkflowTasksBody, {
        includeAssignedTasks: true,
        candidateGroups: permissions,
        processVariables: [
          {
            name: subGrantId === undefined ? 'grantId' : 'subGrantId',
            value: `%${id}%`,
            operator: 'like',
          },
        ],
        taskDefinitionKey: 'completeRfiUserTask',
      });

      REST.workflow
        .getAllExternalEligibleTasks(
          token,
          [subGrantId === undefined ? 'grantId' : 'subGrantId', 'entityId'],
          getWorkflowTasksBody
        )
        .then((res) => {
          if (res.status === 200) {
            return res.json();
          }
        })
        .then((resJson) =>
          this.setState({
            tasks: _.concat(
              _.get(this.state, 'tasks', []),
              this.mergeObjects(resJson, this.props.context.rfis)
            ),
          })
        )
        .catch((error) => {
          console.error('error');
        });
    }

    var subGrantStatus = _.get(this.props.context, 'subGrant.status');
    let mitigatedProperty = _.get(
      this.props.context,
      'fundingOpportunityData.configData.foOverview.mitigatedPropertySiteFundsPaid',
      false
    );

    if (
      _.includes(this.props.toggles, 'enablePropertyDataMitigation') &&
      mitigatedProperty &&
      subGrantStatus &&
      subGrantStatus !== STATUS_CLOSED
    ) {
      this.getPropertyData();
    }
  }

  getJoinedEntityTaskData = (entityType, taskDefinitionKey, statuses, stateKey) => {
    const {token, data: grantId, permissions} = this.props;

    let getWorkflowData = {};
    if (!_.isEmpty(permissions)) {
      getWorkflowData.candidateGroups = permissions;
    }
    _.assign(getWorkflowData, {
      includeAssignedTasks: true,
      processVariables: [
        {
          name: 'grantId',
          value: `%${grantId}%`,
          operator: 'like',
        },
      ],
      taskDefinitionKey: taskDefinitionKey,
    });

    let externalTasks = REST.workflow
      .getAllExternalEligibleTasks(token, ['grantId', 'entityId'], getWorkflowData)
      .then(REST.handler.handleResponse);

    let entity = REST.dynamicData
      .getAllByGrantIdAndEntityType(token, grantId, entityType)
      .then(REST.handler.handleResponse);

    Promise.all([entity, externalTasks]).then((res) => {
      const joinAndReduceJson = _.reduce(
        _.map(res[0], (e) =>
          _.assign(
            e,
            _.find(res[1], (task) => e.entityId == task.entityId)
          )
        ),
        (result, report) => {
          if (_.includes(statuses, report.status)) {
            result.push(report);
          }
          return result;
        },
        []
      );

      let stateObj = {};
      stateObj[stateKey] = joinAndReduceJson;
      this.setState(stateObj);
    });
  };

  mergeObjects = (tasks, rfiObjects) => {
    return _.map(tasks, (t) => {
      const rfiObject = _.head(
        _.filter(rfiObjects, (rfi) => t.entityId === rfi.entityId)
      );
      return {...t, rfi: rfiObject};
    });
  };

  handleContinueCase(entityType, entityId) {
    const {entities} = this.state;
    const {fundingStreamType} = this.props;

    //check and make sure only one payment type
    let continueList = _.filter(entities, (entity) => {
      return entity.entityType === PAYMENT && entity.status === STATUS_PENDING_SUBMISSION;
    });

    if (continueList.length > 1 && fundingStreamType === 'hiringOfFirefighters') {
      this.props.history.push(`/${entityType}/${entityId}/view`);
    } else {
      this.props.history.push(`/${entityType}/${entityId}/edit`);
    }
  }

  doEntityAction(actionType, entity) {
    let entityType = entity.entityType;
    let entityId = entity.entityId;

    switch (actionType) {
      case 'continue':
        this.handleContinueCase(entityType, entityId);
        break;
      case 'withdraw':
        this.setState({selectedEntity: entity}, () => this.showWithdrawModal());
        break;
      case 'reopen':
        this.showReopenModal(entity);
        break;
      default:
    }
  }

  onError = (errors) => {
    this.setState({errors: errors});
  };

  getApplicationExtension = () => {
    REST.fundingOpportunity
      .getFundingOpportunitiesAppExtensionsForGrant(this.props.token, this.props.data)
      .then(REST.handler.handleResponse)
      .then((foAppExtRes) => {
        this.setState({
          appExtDate: _.get(foAppExtRes, [0, 'extendedApplicationEndDate']),
          loading: false,
        });
      })
      .catch((err) => {
        console.error('Request for application data failed.');
      });
  };

  getPropertyData = () => {
    var subGrantId = this.props.subGrant.entityId;
    if (subGrantId) {
      REST.dynamicData
        .getBySubGrantIdAndEntityType(this.props.token, subGrantId, 'propertyData')
        .then(REST.handler.handleResponse)
        .then((resp) => {
          this.setState({
            propertyData: resp,
            loading: false,
          });
        })
        .catch((err) => {
          console.error('Request for propertyData data failed.');
        });
    }
  };

  renderPropertyData = (data) => {
    if (data) {
      return (
        <FemaGoTable.Row key={`${data.entityId}`}>
          <FemaGoTable.TextCell>{`${_.get(data, 'entityType')}`}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>{`${
            ASSOCIATED_ENTITY_STATUSES[_.get(data, 'status')]
          }`}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>
            {ISOToDisplayDate(_.get(data, 'statusTimestamp'), {
              showHours: false,
              showDate: true,
            })}
          </FemaGoTable.TextCell>
          <FemaGoTable.TextCell></FemaGoTable.TextCell>
          <FemaGoTable.TextCell>
            {data.status === STATUS_PENDING_SUBMISSION &&
            canEditPropertyData(this.props.permissions) ? (
              <Dropdown
                selectOnNavigation={false}
                selectOnBlur={false}
                text={'Actions'}
                name={`${data.entityId}-action-button`}
                id={`${data.entityId}-action-button`}
                onChange={() =>
                  this.props.history.push(`/${data.entityType}/${data.entityId}/edit`)
                }
                upward={true}
                options={[
                  {
                    key: 'editPropertyData',
                    text: 'Continue property data mitigation',
                    value: 'propertyData',
                  },
                ]}
              />
            ) : null}
          </FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    }
  };

  renderRFITasks = (task) => {
    if (this.props.context.rfis) {
      return (
        <FemaGoTable.Row key={`${task.id}`}>
          <FemaGoTable.TextCell>{`${_.upperCase(_.get(task, 'rfi.entityType'))} ${_.get(
            task,
            'rfi.entityNumber'
          )}`}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>{`${
            ASSOCIATED_ENTITY_STATUSES[_.get(task, 'rfi.status')]
          }`}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>
            {ISOToDisplayDate(_.get(task, 'rfi.statusTimestamp'), {
              showHours: false,
              showDate: true,
            })}
          </FemaGoTable.TextCell>
          <FemaGoTable.TextCell>
            {ISOToDisplayDate(_.get(task, 'rfi.payload.resubmissionDeadlineTimeStamp'), {
              showHours: false,
              showDate: true,
            })}
          </FemaGoTable.TextCell>
          <FemaGoTable.TextCell>
            <Dropdown
              selectOnNavigation={false}
              selectOnBlur={false}
              text={'Actions'}
              name={`${task.id}-action-button`}
              id={`${task.id}-action-button`}
              onChange={() => this.props.history.push(`/tasks/${task.id}`)}
              upward={true}
              options={[
                {
                  key: 'continue',
                  text: 'Continue request',
                  value: 'continue',
                },
              ]}
            />
          </FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    }
  };

  renderAwards = (task, grant) => {
    return (
      <FemaGoTable.Row key={`${task.id}`}>
        <FemaGoTable.TextCell>Award</FemaGoTable.TextCell>
        <FemaGoTable.TextCell>Not started</FemaGoTable.TextCell>
        <FemaGoTable.TextCell>
          {ISOToDisplayDate(grant.statusTimestamp, {
            showHours: false,
            showDate: true,
          })}
        </FemaGoTable.TextCell>
        <FemaGoTable.TextCell>
          {ISOToDisplayDate(task.awardAcceptanceDueDate, {
            showHours: true,
            showDate: true,
          })}
        </FemaGoTable.TextCell>
        <FemaGoTable.TextCell>
          <Dropdown
            selectOnNavigation={false}
            selectOnBlur={false}
            text={'Actions'}
            name={`${task.id}-action-button`}
            id={`${task.id}-action-button`}
            onChange={() => this.props.history.push(`/tasks/${task.id}`)}
            upward={true}
            options={[
              {
                key: 'continue',
                text: 'Accept or decline award',
                value: 'continue',
              },
            ]}
          />
        </FemaGoTable.TextCell>
      </FemaGoTable.Row>
    );
  };

  render() {
    const {
      data,
      token,
      id,
      grant,
      amendments,
      payments,
      subGrant,
      entityType,
      toggles,
      aplcnEndDate,
      permissions,
      entities: entitiesEnabled,
      closeoutReports,
      subCloseoutReports,
      programType,
      subGrantsForGrant,
      isPassthroughGrant,
    } = this.props;

    const closeoutReportStatus = _.get(closeoutReports, '[0].status', undefined); // see See GMMGO-39113
    const subCloseoutReportStatus = _.get(subCloseoutReports, '[0].status', undefined);

    const {
      entities,
      tasks,
      showMessage,
      appExtDate,
      withdrawShowMessage,
      reopenShowMessage,
      propertyData,
    } = this.state;
    const displayStatuses = [STATUS_PENDING_SUBMISSION, STATUS_RETURNED_TO_RECIPIENT];
    const entitiesToDisplay = _.reduce(
      entities,
      (result, entity) => {
        if (_.includes(displayStatuses, entity.status)) {
          result.push(entity);
        }
        return result;
      },
      []
    );
    const entitiesSize = _.size(entitiesToDisplay);
    const displayErrorMessage = (grantId) => {
      let {errors} = this.state;
      return _.get(errors, 'grantId') == grantId ? (
        <Message
          error
          onDismiss={() => {
            this.setState({errors: null});
          }}
        >
          {_.get(errors, 'errors')}
        </Message>
      ) : null;
    };
    const foData = [];
    foData.push(_.get(this.props.context, 'fundingOpportunityData', {}));
    const subApplicationGrant = _.get(this.props.context, 'subApplicationGrant', {});

    const isAmendmentPaymentSubmitedToFema =
      _.includes(JSON.stringify(amendments), STATUS_SUBMITTED_TO_FEMA) ||
      _.includes(JSON.stringify(payments), STATUS_SUBMITTED_TO_FEMA);
    let actions = getGrantActions(
      grant,
      toggles,
      permissions,
      entitiesEnabled,
      null,
      null,
      null,
      null,
      null,
      null,
      isAmendmentPaymentSubmitedToFema,
      closeoutReportStatus,
      foData,
      amendments,
      null,
      subGrantsForGrant,
      isPassthroughGrant
    );

    const subGrantActions = subGrant
      ? getGrantActions(
          subGrant,
          toggles,
          permissions,
          entitiesEnabled,
          null,
          null,
          null,
          null,
          null,
          null,
          isAmendmentPaymentSubmitedToFema,
          null,
          foData,
          amendments,
          subCloseoutReportStatus,
          null,
          null,
          null,
          propertyData,
          subApplicationGrant
        )
      : [];

    actions = _.uniqBy(_.concat(actions, subGrantActions), 'value');

    let createEntityProps = {
      id: 'create-entity-action-button-item',
      token: token,
      grantId: data,
      actions: actions,
      buttonType: 'primary',
      onError: this.onError,
      showInitiateCloseoutReportModal: this.showInitiateCloseoutReportModal,
      showInitiateSubCloseoutReportModal: this.showInitiateSubCloseoutReportModal,
      showCancelCloseoutReportModal: this.showCancelCloseoutReportModal,
      showCancelSubCloseoutReportModal: this.showCancelSubCloseoutReportModal,
    };
    if (entityType === 'subGrant' && subGrant) {
      createEntityProps = {
        ...createEntityProps,
        entityId: subGrant.entityId,
        entityType: entityType,
        subGrantId: subGrant.subGrantId,
        propertyData: propertyData,
      };
    }

    return (
      <React.Fragment>
        <Confirm
          open={this.state.withdrawModalOpen}
          cancelButton="No"
          confirmButton="Yes"
          content="Are you sure you want to withdraw your request?"
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirmWithdraw}
        />
        <ReopenApplicationModal
          open={this.state.reopenModalOpen}
          entity={this.state.selectedEntity}
          token={this.props.token}
          onCancel={this.handleCancel}
        />
        <InitiateCloseoutReportModal
          open={this.state.initiateCloseoutReportModalOpen}
          entity={this.state.selectedEntity}
          token={this.props.token}
          entityType={this.state.selectedEntityType}
          onCancel={this.handleInitiateCloseoutReport}
          customCloseoutMessage={this.props.customCloseoutMessage}
        />
        <InitiateSubCloseoutReportModal
          open={this.state.initiateSubCloseoutReportModalOpen}
          entity={this.state.selectedEntity}
          token={this.props.token}
          entityType={this.state.selectedEntityType}
          onCancel={this.handleOnCancelInitiateSubCloseoutReport}
        />
        <CancelCloseoutReportModal
          open={this.state.cancelCloseoutReportModalOpen}
          entity={this.state.selectedEntity}
          token={this.props.token}
          onCancel={this.handleCancelCloseoutReport}
        />
        <CancelSubCloseoutReportModal
          open={this.state.cancelSubCloseoutReportModalOpen}
          entity={this.state.selectedEntity}
          token={this.props.token}
          onCancel={this.handleCancelSubCloseoutReport}
        />
        {this.state.errors ? displayErrorMessage(this.state.errors) : null}
        {this.state.errors ? displayErrorMessage(_.get(grant, 'grantId')) : null}
        <CreateEntityActionButton {...createEntityProps} />
        <Segment>
          {withdrawShowMessage ? (
            <Message
              success
              header="Success"
              content={`${_.capitalize(
                this.state.selectedEntity.entityType
              )} has been withdrawn`}
              onDismiss={this.onClose}
            />
          ) : null}

          <Header as={'h3'} content={'My to do list'} id={id} />
          <Grid
            key={'amendmentsGrid'}
            doubling
            stackable
            reversed="mobile"
            padded="vertically"
          >
            <Grid.Column className="visible-overflow">
              <FemaGoTable
                summary={'My to do list for this grant.'}
                type="static"
                columns={5}
              >
                <FemaGoTable.Header>
                  <FemaGoTable.Row>
                    <FemaGoTable.HeaderCell title="Application id">
                      Description
                    </FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell title="Status of grant application">
                      Status
                    </FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell title="Date of status">
                      Date of status
                    </FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell title="Due date">
                      Due date
                    </FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell title="Action for application">
                      Action
                    </FemaGoTable.HeaderCell>
                  </FemaGoTable.Row>
                </FemaGoTable.Header>
                <FemaGoTable.Body>
                  {_.map(tasks, (task) =>
                    task.taskDefinitionKey === 'completeRfiUserTask'
                      ? this.renderRFITasks(task)
                      : this.renderAwards(task, grant)
                  )}

                  {_.map(propertyData, (data) => this.renderPropertyData(data))}

                  {_.map(entitiesToDisplay, (entity, index) => {
                    return (
                      <FemaGoTable.Row key={`${entity.entityId}`}>
                        <FemaGoTable.TextCell>{`${entity.entityType} ${entity.entityNumber}`}</FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>{`${
                          ASSOCIATED_ENTITY_STATUSES[entity.status]
                        }`}</FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          {convertUTCDateToLocalDateDisplay(
                            _.get(entity, 'statusTimestamp'),
                            {
                              showHours: false,
                              showDate: true,
                            }
                          )}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          {entity.status === STATUS_RETURNED_TO_RECIPIENT &&
                            ISOToDisplayDate(
                              _.get(entity, 'payload.review.resubmissionDeadline'),
                              {
                                showHours: false,
                                showDate: true,
                              }
                            )}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          <Dropdown
                            selectOnNavigation={false}
                            selectOnBlur={false}
                            text={'Actions'}
                            name={`${entity.entityId}-action-button`}
                            id={`${entity.entityId}-action-button`}
                            onChange={(e, {name, value}) =>
                              this.doEntityAction(value, entity)
                            }
                            upward={entitiesSize - index < 3} // Dropdown for last two will open up
                            options={[
                              {
                                key: 'continue',
                                text: 'Continue request',
                                value: 'continue',
                              },
                              {
                                key: 'withdraw',
                                text: 'Withdraw request',
                                value: 'withdraw',
                              },
                            ]}
                            value={''}
                          />
                        </FemaGoTable.TextCell>
                      </FemaGoTable.Row>
                    );
                  })}

                  {_.map(this.state.applications, (appl) => {
                    if (
                      !canReopenApplications(
                        permissions,
                        appl.status,
                        appExtDate ? appExtDate : aplcnEndDate,
                        toggles,
                        appl.fundingOpportunityId,
                        appl.programId,
                        programType
                      ) &&
                      !canContinueApplications(
                        permissions,
                        appl.status,
                        appExtDate ? appExtDate : aplcnEndDate,
                        toggles,
                        appl.fundingOpportunityId
                      )
                    ) {
                      return null;
                    }
                    return (
                      <FemaGoTable.Row key={`${appl.grantId}`}>
                        <FemaGoTable.TextCell>{`${appl.grantId}`}</FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          {ASSOCIATED_ENTITY_STATUSES[_.get(appl, 'status')]}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          {ISOToDisplayDate(`${appl.statusTimestamp}`, {
                            showHours: false,
                            showDate: true,
                          })}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          {ISOToDisplayDate(appExtDate ? appExtDate : aplcnEndDate, {
                            showHours: false,
                            showDate: true,
                          })}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          <Dropdown
                            selectOnNavigation={false}
                            selectOnBlur={false}
                            text={
                              canReopenApplications(
                                permissions,
                                appl.status,
                                appExtDate ? appExtDate : aplcnEndDate,
                                toggles,
                                appl.fundingOpportunityId,
                                appl.programId,
                                programType
                              )
                                ? 'Reopen application'
                                : canContinueApplications(
                                    permissions,
                                    appl.status,
                                    appExtDate ? appExtDate : aplcnEndDate,
                                    toggles,
                                    appl.fundingOpportunityId
                                  )
                                ? 'Continue application'
                                : 'View application'
                            }
                            name={`${appl.entityId}-action-button`}
                            id={`${appl.entityId}-action-button`}
                            onChange={(e, {name, value}) =>
                              this.doEntityAction(value, appl)
                            }
                            options={
                              canReopenApplications(
                                permissions,
                                appl.status,
                                appExtDate ? appExtDate : aplcnEndDate,
                                toggles,
                                appl.fundingOpportunityId,
                                appl.programId,
                                programType
                              )
                                ? [
                                    {
                                      key: 'reopen',
                                      text: 'Reopen application',
                                      value: 'reopen',
                                    },
                                  ]
                                : canContinueApplications(
                                    permissions,
                                    appl.status,
                                    appExtDate ? appExtDate : aplcnEndDate,
                                    toggles,
                                    appl.fundingOpportunityId
                                  )
                                ? [
                                    {
                                      key: 'continue',
                                      text: 'Continue application',
                                      value: 'continue',
                                    },
                                  ]
                                : [
                                    {
                                      key: 'view',
                                      text: 'View application',
                                      value: 'view',
                                    },
                                  ]
                            }
                            value={''}
                          />
                        </FemaGoTable.TextCell>
                      </FemaGoTable.Row>
                    );
                  })}
                  {_.map(
                    _.orderBy(this.state.financialReports, 'statusTimestamp', 'desc'),
                    (report) => {
                      return (
                        <FemaGoTable.Row key={`${report.grantId}`}>
                          <FemaGoTable.TextCell>
                            Federal Financial Report for period ending{' '}
                            {ISOToDisplayDate(
                              `${_.get(report, 'payload.reportingPeriodEndDate')}`,
                              {
                                showHours: false,
                                showDate: true,
                              }
                            )}
                          </FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>Pending submission</FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>
                            {ISOToDisplayDate(`${report.statusTimestamp}`, {
                              showHours: false,
                              showDate: true,
                            })}
                          </FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>
                            {ISOToDisplayDate(`${_.get(report, 'payload.reportDue')}`, {
                              showHours: false,
                              showDate: true,
                            })}
                          </FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>
                            <Dropdown
                              selectOnNavigation={false}
                              selectOnBlur={false}
                              text={'Actions'}
                              name={`${report.entityId}-action-button`}
                              id={`${report.entityId}-action-button`}
                              onChange={() =>
                                this.props.history.push(`/tasks/${report.id}`)
                              }
                              options={
                                grant.status ===
                                  STATUS_ADMINISTRATIVE_CLOSEOUT_INITIATED ||
                                grant.status === STATUS_ADMINISTRATIVELY_CLOSED
                                  ? []
                                  : [
                                      {
                                        key: 'continue',
                                        text: 'Continue Federal Financial Report',
                                        value: 'continue',
                                      },
                                    ]
                              }
                            />
                          </FemaGoTable.TextCell>
                        </FemaGoTable.Row>
                      );
                    }
                  )}
                  {_.map(
                    _.orderBy(this.state.bsirReports, 'statusTimestamp', 'desc'),
                    (report) => {
                      return (
                        <FemaGoTable.Row key={`${report.grantId}`}>
                          <FemaGoTable.TextCell>
                            Biannual Strategy Implementation Report for period ending{' '}
                            {ISOToDisplayDate(
                              `${_.get(report, 'payload.reportingPeriodEndDate')}`,
                              {
                                showHours: false,
                                showDate: true,
                              }
                            )}
                          </FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>Pending submission</FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>
                            {ISOToDisplayDate(`${report.statusTimestamp}`, {
                              showHours: false,
                              showDate: true,
                            })}
                          </FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>
                            {ISOToDisplayDate(`${_.get(report, 'payload.reportDue')}`, {
                              showHours: false,
                              showDate: true,
                            })}
                          </FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>
                            <Dropdown
                              selectOnNavigation={false}
                              selectOnBlur={false}
                              text={'Actions'}
                              name={`${report.entityId}-action-button`}
                              id={`${report.entityId}-action-button`}
                              onChange={() =>
                                this.props.history.push(`/tasks/${report.id}`)
                              }
                              options={[
                                {
                                  key: 'continue',
                                  text:
                                    'Continue Biannual Strategy Implementation Report',
                                  value: 'continue',
                                },
                              ]}
                            />
                          </FemaGoTable.TextCell>
                        </FemaGoTable.Row>
                      );
                    }
                  )}
                  {_.map(
                    _.orderBy(
                      this.state.performanceProgressReports,
                      'statusTimestamp',
                      'desc'
                    ),
                    (report) => {
                      return (
                        <FemaGoTable.Row key={`${report.entityId}`}>
                          <FemaGoTable.TextCell>
                            Performance Progress Report for period ending{' '}
                            {_.get(report, 'payload.reportingPeriodEndDate')
                              ? ISOToDisplayDate(
                                  `${_.get(report, 'payload.reportingPeriodEndDate')}`,
                                  {
                                    showHours: false,
                                    showDate: true,
                                  }
                                )
                              : _.get(report, 'payload.request.reportingPeriodEndDate')
                              ? ISOToDisplayDate(
                                  `${_.get(
                                    report,
                                    'payload.request.reportingPeriodEndDate'
                                  )}`,
                                  {
                                    showHours: false,
                                    showDate: true,
                                  }
                                )
                              : ''}
                          </FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>{`${
                            ASSOCIATED_ENTITY_STATUSES[_.get(report, 'status')]
                          }`}</FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>
                            {ISOToDisplayDate(`${report.statusTimestamp}`, {
                              showHours: false,
                              showDate: true,
                            })}
                          </FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>
                            {report.status === STATUS_RETURNED_TO_RECIPIENT ||
                            !_.isEmpty(
                              _.get(report, 'payload.review.resubmissionDeadline')
                            )
                              ? ISOToDisplayDate(
                                  _.get(report, 'payload.review.resubmissionDeadline'),
                                  {
                                    showHours: false,
                                    showDate: true,
                                  }
                                )
                              : ISOToDisplayDate(_.get(report, 'payload.reportDue'), {
                                  showHours: false,
                                  showDate: true,
                                })}
                          </FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>
                            <Dropdown
                              selectOnNavigation={false}
                              selectOnBlur={false}
                              text={'Actions'}
                              name={`${report.entityId}-action-button`}
                              id={`${report.entityId}-action-button`}
                              onChange={() =>
                                _.get(report, 'payload.reportPastDue')
                                  ? this.props.history.push(`/tasks/${report.id}`)
                                  : this.props.history.push(
                                      `/${report.entityType}/${report.entityId}/edit`
                                    )
                              }
                              options={
                                grant.status ===
                                  STATUS_ADMINISTRATIVE_CLOSEOUT_INITIATED ||
                                grant.status === STATUS_ADMINISTRATIVELY_CLOSED
                                  ? []
                                  : [
                                      {
                                        key: 'continue',
                                        text: 'Complete Performance Progress Report',
                                        value: 'continue',
                                      },
                                    ]
                              }
                            />
                          </FemaGoTable.TextCell>
                        </FemaGoTable.Row>
                      );
                    }
                  )}
                  {_.map(this.state.closeoutReports, (report) => {
                    return (
                      <FemaGoTable.Row key={`${report.entityId}`}>
                        <FemaGoTable.TextCell>
                          Closeout report{' '}
                          {_.get(report, 'payload.request.reportingPeriodEndDate')
                            ? ISOToDisplayDate(
                                `${_.get(
                                  report,
                                  'payload.request.reportingPeriodEndDate'
                                )}`,
                                {
                                  showHours: false,
                                  showDate: true,
                                }
                              )
                            : ''}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>{`${
                          ASSOCIATED_ENTITY_STATUSES[_.get(report, 'status')]
                        }`}</FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          {ISOToDisplayDate(`${report.statusTimestamp}`, {
                            showHours: false,
                            showDate: true,
                          })}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          {ISOToDisplayDate(
                            _.get(grant, 'payload.closeoutReportingDeadline'),
                            {
                              showHours: false,
                              showDate: true,
                            }
                          )}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          <Dropdown
                            selectOnNavigation={false}
                            selectOnBlur={false}
                            text={'Actions'}
                            name={`${report.entityId}-action-button`}
                            id={`${report.entityId}-action-button`}
                            onChange={() =>
                              this.props.history.push(
                                `/${report.entityType}/${report.entityId}/edit`
                              )
                            }
                            options={[
                              {
                                key: 'continue',
                                text: 'Continue closeout report',
                                value: 'continue',
                              },
                            ]}
                          />
                        </FemaGoTable.TextCell>
                      </FemaGoTable.Row>
                    );
                  })}
                  {_.map(subCloseoutReports, (report) => {
                    if (
                      !report ||
                      !_.includes(STATUS_PENDING_SUBMISSION, report.status) ||
                      !canInitiateOrContinueSubCloseoutReport(
                        permissions,
                        _.get(grant, 'organizationId')
                      )
                    )
                      return;
                    return (
                      <FemaGoTable.Row key={`${report.entityId}`}>
                        <FemaGoTable.TextCell>
                          Subgrant closeout report{' '}
                          {_.get(report, 'payload.request.reportingPeriodEndDate')
                            ? ISOToDisplayDate(
                                `${_.get(
                                  report,
                                  'payload.request.reportingPeriodEndDate'
                                )}`,
                                {
                                  showHours: false,
                                  showDate: true,
                                }
                              )
                            : ''}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>{`${
                          ASSOCIATED_ENTITY_STATUSES[_.get(report, 'status')]
                        }`}</FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          {ISOToDisplayDate(`${report.statusTimestamp}`, {
                            showHours: false,
                            showDate: true,
                          })}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          {ISOToDisplayDate(
                            _.get(grant, 'payload.closeoutReportingDeadline'),
                            {
                              showHours: false,
                              showDate: true,
                            }
                          )}
                        </FemaGoTable.TextCell>
                        <FemaGoTable.TextCell>
                          <Dropdown
                            selectOnNavigation={false}
                            selectOnBlur={false}
                            text={'Actions'}
                            name={`${report.entityId}-action-button`}
                            id={`${report.entityId}-action-button`}
                            onChange={() =>
                              this.props.history.push(
                                `/${report.entityType}/${report.entityId}/edit`
                              )
                            }
                            options={[
                              {
                                key: 'continue',
                                text: 'Continue subgrant closeout report',
                                value: 'continue',
                              },
                            ]}
                          />
                        </FemaGoTable.TextCell>
                      </FemaGoTable.Row>
                    );
                  })}
                </FemaGoTable.Body>
              </FemaGoTable>
            </Grid.Column>
          </Grid>
        </Segment>
      </React.Fragment>
    );
  }
}

export default withRouter(connectDynamic(MyToDoList));
